import {
  sanitizeText,
  formatDate,
} from "../../components/paymentPromo/hooks/utils";

const individualProductTemplate = (data) => ({
  "@type": "IndividualProduct",
  name: sanitizeText(data.name),
  sku: sanitizeText(data.sku),
  color: sanitizeText(data.color),
  image: sanitizeText(data.image),
  brand: brandTemplate(data.brand),
});

export const brandTemplate = (data) => {
  const brandSchema = {
    "@type": "Brand",
    name: sanitizeText(data.name),
  };

  if (data.reviews && data.reviews.length > 0) {
    brandSchema.review = reviewsTemplate(data.reviews);
  }

  return brandSchema;
};

const sellerTemplate = () => ({
  "@type": "Organization",
  name: "ASOS",
});

export const mapOffersToTemplate = (data) =>
  data.offers.map((offer) => offerTemplate(offer));

export const offerTemplate = (data) => ({
  "@type": "Offer",
  price: data.price,
  priceCurrency: sanitizeText(data.currency),
  itemOffered: individualProductTemplate(data.product),
  seller: sellerTemplate(),
  availability: data.isInStock
    ? "https://schema.org/InStock"
    : "https://schema.org/OutOfStock",
  itemCondition: "https://schema.org/NewCondition",
});

export const ratingsTemplate = (ratings) => ({
  "@type": "AggregateRating",
  ratingValue: ratings.averageOverallRating,
  ratingCount: ratings.totalReviewCount,
  bestRating: 5,
  worstRating: 1,
});

const sanitizeReviewBody = (text = "") =>
  sanitizeText(text).substring(0, 300) || "No review text provided";

const createReviewRating = (rating) => ({
  "@type": "Rating",
  bestRating: 5,
  worstRating: 1,
  ratingValue: String(typeof rating === "number" && rating >= 1 ? rating : 1),
});

const createAuthor = (author) => ({
  "@type": "Person",
  name: sanitizeText(author || "Anonymous"),
});

const mapReviewToTemplate = (review) => ({
  "@type": "Review",
  reviewRating: createReviewRating(review.rating),
  author: createAuthor(review.author),
  datePublished: formatDate(review.date || new Date()),
  name: sanitizeText(review.title || "No title provided"),
  reviewBody: sanitizeReviewBody(review.reviewText || ""),
});

export const reviewsTemplate = (reviews = []) => {
  return reviews
    .filter((review) => review && typeof review === "object")
    .slice(0, 3)
    .map(mapReviewToTemplate);
};
